import { useTranslation } from 'react-i18next'
import { WebhookTemplateData } from '../../../../types'
import { InfoTable, Tag } from '../../../../ui'
import VariableDisplay from '../../../../ui/form/VariableDisplay'

export const WebhookTable = ({ data }: { data: WebhookTemplateData }) => {
    const { t } = useTranslation()
    return <InfoTable rows={{
        [t('method')]: data.method ?? <Tag variant="warn">{t('missing')}</Tag>,
        [t('endpoint')]: data.endpoint
            ? <VariableDisplay value={data.endpoint} />
            : <Tag variant="warn">{t('missing')}</Tag>,
        [t('headers')]: JSON.stringify(data.headers),
        [t('body')]: JSON.stringify(data.body),
        [t('cache_key')]: data.cache_key
            ? <VariableDisplay value={data.cache_key} />
            : undefined,
    }} />
}
